import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FlyingRobots from '../components/FlyingRobots';
import { blogPosts } from '../mock';
import useScrollReveal from '../hooks/useScrollReveal';

export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const post = blogPosts.find((p) => p.slug === slug);

  useScrollReveal([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!post) {
      navigate('/blog');
    }
  }, [navigate, post]);

  if (!post) {
    return null;
  }

  return (
    <div className="bg-[#050506] text-white relative min-h-screen">
      <FlyingRobots />
      <Navbar />

      <article className="relative py-[80px] overflow-hidden">
        <div className="halftone" />
        <div className="relative mx-auto max-w-[800px] px-6">
          <div className="mb-8">
            <p className="eyebrow text-white/50 mb-3 text-[13px]">{post.date}</p>
            <h1 className="h-display text-[42px] md:text-[56px] leading-[1.1] mb-4">
              {post.title}
            </h1>
            <p className="text-white/60 text-[16px]">By {post.author}</p>
          </div>

          <div className="space-y-12 mt-12">
            {post.sections.map((section, idx) => (
              <div key={idx}>
                <h2 className="h-sans text-[24px] md:text-[32px] font-medium mb-4 text-[#10b981]">
                  {section.heading}
                </h2>
                <p className="text-white/70 text-[16px] leading-[1.8] whitespace-pre-wrap">
                  {section.body}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-16 pt-8 border-t border-white/10">
            <h3 className="h-sans text-[16px] font-medium text-white/50 mb-3">Further reading</h3>
            <a
              href={post.furtherReading.url}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center text-[#10b981] hover:text-[#06b6d4] transition-colors group text-[15px]"
            >
              {post.furtherReading.label}
              <svg
                className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </a>
          </div>

          <div className="mt-12">
            <a
              href="/blog"
              className="inline-flex items-center text-white/60 hover:text-white transition-colors text-[14px]"
            >
              <svg
                className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Back to blog
            </a>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}
